module.exports = __webpack_public_path__ + "static/media/ChaloMenu 3.b5b0a012.jpg";